import Vue from 'vue'
import App from './App.vue'
import router from '@/router.js'
import store from '@/store.js'
import vuetify from './plugins/vuetify'

import VueCordova from 'vue-cordova'
import VueOffline from 'vue-offline'
import VuePlyr from 'vue-plyr'

import axios from 'axios'

Vue.use(VueCordova)
Vue.use(VueOffline)

Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: false }
  },
  emit: ['ended']
})

Vue.config.productionTip = false

axios.defaults.xsrfHeaderName = "X-CSRFToken";
Vue.prototype.$axios = axios

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}

Vue.prototype.$appname = 'Nehlueun'

if (process.env.CORDOVA_PLATFORM) {
    Vue.prototype.$app_url = "https://nehlueun.com"
    Vue.prototype.$api_url = "https://nehlueun.com/api/v1"
    // Vue.prototype.$app_url = "https://application-langue-nehlueun-stage.us.aldryn.io"
    // Vue.prototype.$api_url = "https://application-langue-nehlueun-stage.us.aldryn.io/api/v1"
} else {
    Vue.prototype.$app_url = window.location.origin
    Vue.prototype.$api_url = window.location.origin+"/api/v1"
}

/* ============================ FILTERS ============================ */

var filter = function (t, l, c) {
  c = c || ''
  var node = document.createElement('div')
  node.innerHTML = t
  var content = node.textContent
  return content.length > l ? content.slice(0, l) + c : content
}
Vue.filter('truncate', filter)

/* ================================================================= */

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
